import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/emitter-templates/$templateId/instances'
)({
  component: () => <Outlet />,
});
